































import { Vue, Component, Prop } from 'vue-property-decorator';
import to from 'await-to-js';
import moduleStore from '../store/migu';
import { MiguConfig } from '../utils/constant';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class workTemplate extends Vue {

  @Prop({ default: false })
  isNewYear: boolean;

  @Prop({ default: '' })
  taskId!: string;

  @Prop({ default: 'reload' })
  createMode!: string; // 'reload' = 跳转创作页, 'open-create-drawer' = 打开创作抽屉

  loading: Boolean = false;
  finished: Boolean = true;
  page: number = 1;
  pageSize: number = 10;
  total_pages: number = 0;
  list = [];
  
  async mounted() {
    await this.getList();
    this.$nextTick(() => {
      this.$emit('anchor');
    })
  }

  async getList() {
    this.loading = true;
    this.finished = false;

    const [err, res] = await to(this.$http('getTemplateList', {
      page: this.page,
      pageSize: this.pageSize,
      resourceType: 'ONE_CLICK'
    }));

    this.loading = false;
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    const arr = res.data.results || [];
    this.list = this.page === 1 ? arr : [...this.list, ...arr];
    this.total_pages = res.data.total_pages;
    if (this.page >= this.total_pages) {
      this.finished = true;
    }
  }

  upLoadData() {
    if(this.page >= this.total_pages) return;
    this.page += 1;
    this.getList();
  }

  // 获取制作同款保存数据
  getSaveData(item) {
    const { styleEN, speakerSpeed, speakerName, speakerStyle, description } = item;
    const data = { text: description, styleCode: styleEN, speakerName, speakerStyle, speechSpeed: speakerSpeed };
    return JSON.stringify(data);
  }

  // 登录校验：组件内无登录弹窗，未登录时 emit 请求父页面弹 simple-login-phone
  checkLogin(): boolean {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.$emit('show-login');
        return false;
      }
    }
    return true;
  }
  // 跳转播放页
  doJumpPlayPage(item) {
    // 未登录不进行后续逻辑，由父页面弹登录窗
    if (!this.checkLogin()) return;
    localStorage.setItem('videoMiguData', this.getSaveData(item));
    // 将模板列表存入 localStorage，供 videoPlay 上下滑动切换
    const playList = this.list.map((v: any) => ({
      videoUrl: v.videoUrl,
      coverUrl: v.coverUrl,
      articleId: v.articleId,
      description: v.description,
      styleEN: v.styleEN,
      speakerSpeed: v.speakerSpeed,
      speakerName: v.speakerName,
      speakerStyle: v.speakerStyle,
    }));
    localStorage.setItem('videoPlayList', JSON.stringify(playList));
    const { videoUrl, coverUrl, articleId } = item;
    this.$router.push({ path: '/video-play', query: { videoUrl, coverUrl, type: '2', articleId, taskId: this.taskId, swipeable: '1' } });
  }
  // 点击"我也试试" → 打开创作抽屉
  onCreateClick(item) {
    // 未登录不进行后续逻辑，由父页面弹登录窗
    if (!this.checkLogin()) return;
    localStorage.setItem('textToVideoMiguData', this.getSaveData(item));
    try {
      if ((window as any)._amberTrack) {
        const vuid = localStorage.getItem('vuid') || '';
        (window as any)._amberTrack('music_aigc_submit_task_directly', [
          {
            EK: 'triggerType',
            EV: '2'
          },
          {
            EK: 'scene',
            EV: MiguConfig.projectId
          },
          {
            EK: 'taskId',
            EV: this.taskId
          },
          {
            EK: 'vuid',
            EV: vuid
          },
          {
            EK: 'appId',
            EV: MiguConfig.appid
          },
          {
            EK: 'channel',
            EV: MiguConfig.schannel
          }
        ], true, 'beacon');
        console.log('_amberTrack music_aigc_submit_task_directly',
        {
          EK: 'taskId',
          EV: this.taskId
        },
        {
          EK: 'vuid',
          EV: vuid
        });
      }
    } catch (e) { }
    this.$emit(this.createMode);
  }
}
